var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-container"},[_c('div',{staticClass:"canvas"},[_c('canvas',{staticStyle:{"width":"80px","height":"80px"},attrs:{"id":_vm.id,"width":"160","height":"160"}}),_c('p',{staticClass:"percent"},[_vm._v(_vm._s(_vm.n.toFixed(0) + "%"))])]),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }